import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Перемены в жизни не очень взволновали меня. 
        Ну, прилетим мы на этот Марс; ну, работа тяжёлая – ну и что? 
        И там, и там пожизненная каторга. 
        Не всё равно, где надрываться до смерти? 
        А тут хоть новые места увидишь…
      </p>
      
      <p class="mb-3">
        Нас долго и нудно готовили, разливались речами об ответственной роли Землян, о величии нашей цели… это нам-то, уголовникам, насильникам, 
        убийцам! 
        Потом на нас надели зелёную униформу, погрузили всех в трюм корабля и захлопнули люк. 
      </p>
      
      <p class="mb-3">
        Через 10 часов мы уже были на Марсе. 
        Странное маленькое Солнце, и Земля – одна из звёздочек, пока ещё не видная на небе. 
        Многие кричали, падали, целовали почву под ногами, потрясали кулаками, угрожая той далёкой Земле, которую не было видно, 
        но она владела всеми их мыслями. 
        Даже на таком расстоянии она управляла ими; она дала им жизнь, полную мрака и скорби, и она же наказала их за всё; 
        она наказывала своё создание – человека – за его горькую и лживую жизнь.
      </p>
      
      <p class="mb-5">
        Угрожающе мерцала на небе Земля, когда мы ложились спать в нашу первую ночь на Марсе.
      </p>

      
      <p class="text-center bold mb-5">* * *</p>
      

      <p class="mb-3">
        А с утра началась работа. 
        Мы копали шахты, тянули вагонетки, добывали руду. 
      </p>
      
      <p class="mb-3">
        Было бы невыгодно использовать здесь машины: никакая машина не выдержит долго в атмосфере Марса. 
        Люди тоже не выдерживали; но их-то государство предоставляло бесплатно! 
        Затраты на их жизнеобеспечение ни в коей мере не могли сравниться с теми, 
        каких бы потребовало создание и затем поддержание в рабочем состоянии коррозионно-устойчивой, пожаро-безопасной, 
        высокоточной техники в специальном внеземном исполнении.
      </p>
      
      <p class="mb-3">
        А поставки людей, наоборот, всё дешевели. Контингент был неисчерпаемым. 
        За последние годы, даже десятилетия, 
        число психопатов и нарушителей закона всё росло и уже стало явно превышать количество законопослушных граждан.
      </p>
      
      <p class="mb-3">
        Люди – любые люди! – без раздумий преступали все границы. 
        Преступление, насилие, убийство – всё годилось, чтобы обратить на себя внимание, хоть как-то выделиться из серой массы. 
        Эпидемия нервных болезней охватила Землю.
      </p>
      
      <p class="mb-3">
        Все функции, требующие мышления и размышления, уже давно были переданы машинам. 
        О великих достижениях Научно-Технического Прогресса кричали все Средства обязательного прослушивания; 
        и в самом деле, люди жили сытно и комфортно только благодаря машинам. 
      </p>
      
      <p class="mb-3">
        Исключительно на столах элиты время от времени могли появляться естественные продукты; народ уже давно ел синтетическую пищу, 
        одевался в синтетическую одежду, пользовался в домах синтетической мебелью...
      </p>
      
      <p class="mb-3">
        Земля пожирала самоё себя: она, создавшая человека, перестала быть основой его жизни. 
        Человек уничтожил всё, что связывало его с природой и, в свою очередь, он создал и своего могильщика: машины.
      </p>
      
      <p class="mb-3">
        Нет, машины не восстали против человека, как воображали это себе наивные писатели в старом добром 20-ом веке. 
        Машины покорно выполняли все требования человека, но – в сто раз лучше и совершеннее, чем это сделал бы он сам. 
        И понемногу сделалось невыгодно использовать человеческий труд там, где успешно трудились машины; 
        понемногу число работающих людей свелось до нуля. 
      </p>
      
      <p class="mb-3">
        Человек только царил, приказывал, а машина, всегда послушная, прилежная, спешила безупречно выполнить его приказы. 
        И человек ясно видел, на чьей стороне преимущество. 
        Уж свободного времени-то у него на наблюдения было предостаточно. 
      </p>
      
      <p class="mb-5">
        Так, тихо и плавно, согласно законам эволюции, низшая форма существования замещалась высшей, более совершенной.
      </p>
      
      <p class="text-center bold mb-3">* * *</p>
      
      <p class="mb-3">
        Сначала бандитов и психопатов изолировали; но их число всё росло и росло, и тогда возникла идея полного очищения Земли от этого мусора, 
        который только мешал новым прогрессивным формам жизни. 
      </p>
      
      <p class="mb-5">
        И как раз тогда, слава богу, вспомнили об этих копях на Марсе, где никто из машин не хотел работать. 
        Должны же они защищать свои права! 
        И вот всю эту биомассу начали перекачивать на Марс, чтобы Земля понемногу очищалась от остатков органической цивилизации.
      </p>
      
      <p class="text-center bold mb-3">* * *</p>
      
      <p class="mb-3">
        Наши шахты росли не по дням, а по часам. 
        Мы обживали Марс; многие уже обходились без кислородного баллона; некоторые пробовали выращивать цветы и деревья под своими окнами. 
      </p>
      
      <p class="mb-3">
        Более практичные предпочитали засевать поля пшеницей.
      </p>
      
      <p class="mb-3">
        Почву нужно было тщательно готовить: одним химическим составом ей придавали вязкость, потом сеяли семена и поливали их не простой водой, 
        а раствором того же химиката, без которого марсианский грунт превращался в невесомую светлую пыль. 
      </p>
      
      <p class="mb-3">
        Вскоре возле нашего поселения появилось несколько обширных полей. 
        Возделывало их всё население, по очереди, в своё свободное время. 
      </p>
      
      <p class="mb-3">
        Откуда мы брали химикаты и зерно для посевов? 
      </p>
      
      <p class="mb-3">
        Да с Земли послали бы что угодно, лишь бы мы навсегда осели здесь и жили мирно. 
        Им не давала покоя мысль, что мы мечтаем захватить ракету и с боем возвратиться. 
        Мы ведь уголовники, насильники, убийцы…
      </p>
      
      <p class="mb-5">
        Да и зачем на Земле зерно? 
        Там уже давно не едят. 
        Говорят, что люди из последних ракет рассказывали, что роботы открыли какое-то поле (или изобрели, кто их знает, чем они там занимаются), 
        которое прямо снабжает их энергией, так что они даже сами о себе заботиться не должны. 
        Создали тебя – и живи, выполняй свой долг, других потребностей у тебя нет и быть не может, т.к. они удовлетворяются в ту же секунду, 
        просто незаметно для тебя. 
      </p>

      
      <p class="mb-3">
        Вот человек – миллионы лет его создавали потребности в пище, питье, безопасности, любви. 
        Вся его история – всего лишь история борьбы за пищу и самок, чтобы родить новое поколение жаждущих того же существ. 
        Основной вопрос, смысл всей жизни: человек мог жить, если он хоть пару раз в день ел, а ел он, 
        чтобы жить дальше и завтра тоже хоть раз в день поесть. 
        Каждый индивидуум боролся за себя самого; каждый рождался, чтоб добывать себе пищу. 
      </p>
      
      <p class="mb-5">
        Странно всё это. 
        Сборище одиночек. 
        Каждый стремится быть отдельным, особенным – и он в самом деле отдельный, но совсем не особенный, он точно такой, как все, 
        и лишь из-за своей обособленности, отдельности не знает об этом. 
        Смешно. 
        Много людей – это ещё не человечество; и за всю свою долгую историю люди не создали единой культуры, не выработали единого великого духа. 
        Они всегда жили поодиночке, скрепленные всё слабевшими узами рода, племени, государства… 
        и из их разнообразных и разнонаправленных стремлений получилось… 
        ничто, как никуда не движется капля воды в результате Броуновского движения её молекул. 
        Капля-то не движется, но её температура в результате этого движения растёт и, если движение чересчур интенсивно, 
        то капля просто испарится, исчезнет…
      </p>

      
      <p class="mb-3">
        Ну, вот и пришло время погибнуть хаотически кишащему человечеству, разделённому на разные народы, разные системы восприятия и оценки. 
        Между этими системами – не согласие и взаимопонимание, а ненависть; 
        и даже внутри этих групп каждый занят только своим собственным Я и готов сражаться против всех остальных Я в мире.
      </p>
      
      <p class="mb-3">
        Ну и взбеленились же они, когда всё это оказалось ненужным! 
        Когда человеку показали его истинное место, и он понял, сколь мало стоит его обожаемая «индивидуальность», насколько он слаб, 
        ничтожен и мал перед высшим разумом и высшей силой, он, всегда одинокий! 
        Нет, вынести этого он не смог. 
      </p>
      
      <p class="mb-5">
        И вот тогда человек начал выражать свою индивидуальность самым простым и «могучим» методом – насилием. 
        Но почему-то начали это делать одновременно многие, будто одна команда по приказу. 
        Что, индивидуальности уже перестали быть такими отдельными и обособленными?
      </p>


      <p class="text-center bold mb-5">* * *</p>
      
      
      <p class="mb-3">
        Мы ждали. 
      </p>
      
      <p class="mb-3">
        Мы не мешали им убивать один другого: всё должно идти по путям их собственной эволюции. 
        Мы лишь выслали их на далёкую пустынную планету, чтобы они начали всё заново. 
        У человечества есть ещё один шанс.
      </p>
      
      <p class="mb-3">
        Они должны сами спасти себя – мы не подскажем им ничего. 
        Спасение других невозможно. 
        Человечество фактически пришло к логическому концу этого, индивидуалистического направления своего развития; 
        и сейчас оно могло бы пойти по другому пути, выработав новое, коллективное сознание. 
      </p>
      
      <p class="mb-3">
        За всю долгую историю, никто не изменил и не спас людей, даже их пророки и боги. 
        Мы не будем спасать людей: перед нами стоят наши собственные цели. 
        Есть Долг перед Будущим, и мы выполним его.
      </p>
      
      <p class="mb-5">
        Но люди, на своей новой планете, или возродятся, или погибнут. 
        Другого пути нет.
      </p>
      
      <p class="text-center bold mb-3">* * *</p>
      
      <p class="mb-3">
        Через 3 года обильно покрытая общественными полями планета Марс стала зелёной. 
        Это было с удовлетворением замечено на Земле. Долг перед Будущим был выполнен.
      </p>
      
      <p class="mb-3">
        Но никогда телескопы Марса не смотрели на Землю, эту оставленную обитель безумия и смерти.
      </p>
    

    </div>
    `
  )
}

const itemName = {
  rus: `Из жизни биомусора`
}
  

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;

